export default __webpack_public_path__ + "static/media/digital_en_green.6cf40769.png";